module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-keyvisual_en_sp-049e8f3d4f37b82a570e0d4057f119b9.png";